import { link } from "constants/architectsTranslation";

function LinkSection({ link, text }: link) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="text-decoration-none d-flex align-items-center mb-3"
    >
      {text}
    </a>
  );
}

export default LinkSection;
